import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import WeeklyChallangeTable from "../../../../Components/Table/WeeklyChallangeTable";
import { GetChallenges } from "../../../../APIs/Function/Workout/Challenges/GetChallenges";
import CustomButton from "../../../../Components/Button/CustomButton";
import { Link } from "react-router-dom";

const WeeklyChallanges = () => {
  const [challengesData, setChallengesData] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleChallenges = async () => {
    try {
      setLoading(true);
      let res = await GetChallenges();
      setChallengesData(res.r);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    handleChallenges();
  }, []);
  return (
    <>
      <Box sx={{ p: 2 }}>
        <WeeklyChallangeTable
          setData={setChallengesData}
          data={challengesData}
          loadinga={loading}
          Column1={"#"}
          Column2={"Title"}
          Column3={"Challenge Type"}
          Column4={"Parameter"}
          Column5={"Description"}
          Column6={"Action"}
        />
        <Box
          sx={{
            display: "flex",
            mt: "25px",
            justifyContent: "end",
            width: "100%",
          }}
        >
          <Link to={"/addchallenges"}>
            <CustomButton
              sx={{
                width: "100%",
                bgcolor: "#31AEF4",
                "&:hover": {
                  bgcolor: "#31AEF4",
                },
              }}
            >
              ADD +
            </CustomButton>
          </Link>
        </Box>
      </Box>
    </>
  );
};

export default WeeklyChallanges;
